const B = process.env.REACT_APP_BACKEND_URL;

function base64UrlToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return false;
  const registration = await navigator.serviceWorker.ready;
  const { publicKey } = await fetch(`${B}/api/push/public-key`, { credentials: "include" }).then((r) => r.json());
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64UrlToUint8Array(publicKey),
    });
  }
  const res = await fetch(`${B}/api/push/subscriptions`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(subscription.toJSON()),
  });
  if (!res.ok) throw new Error("Could not save push subscription");
  return true;
}

export async function fetchUnreadCount() {
  try {
    const res = await fetch(`${B}/api/chat/unread-count`, { credentials: "include" });
    if (!res.ok) return 0;
    return (await res.json()).unread || 0;
  } catch {
    return 0;
  }
}

export async function markThreadRead(threadId) {
  try {
    await fetch(`${B}/api/chat/threads/${threadId}/read`, { method: "POST", credentials: "include" });
  } catch { /* best effort */ }
}

export function syncAppBadge(count) {
  if (!("setAppBadge" in navigator)) return;
  if (count > 0) navigator.setAppBadge(count).catch(() => {});
  else if ("clearAppBadge" in navigator) navigator.clearAppBadge().catch(() => {});
}
